import typographyImageA from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-a.png";
import typographyImageB from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-b.png";
import typographyImageH from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-h.png";
import typographyImageV from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-v.png";
import typographyImageJ from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-j.png";
import typographyImageS from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-s.png";
import typographyImageI from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-i.png";
import typographyImageX from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-x.png";
import typographyImageZ from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-z.png";
import typographyImageQ from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-q.png";
import typographyImageW from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-w.png";
import typographyImageT from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-t.png";
import typographyImageU from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-u.png";
import typographyImageC from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-c.png";
import typographyImageD from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-d.png";
import typographyImageE from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-e.png";
import typographyImageF from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-f.png";
import typographyImageG from "../../../../src/pages/whats-new/implementing-typography-at-scale/_images/typography-image-g.png";
import * as React from 'react';
export default {
  typographyImageA,
  typographyImageB,
  typographyImageH,
  typographyImageV,
  typographyImageJ,
  typographyImageS,
  typographyImageI,
  typographyImageX,
  typographyImageZ,
  typographyImageQ,
  typographyImageW,
  typographyImageT,
  typographyImageU,
  typographyImageC,
  typographyImageD,
  typographyImageE,
  typographyImageF,
  typographyImageG,
  React
};